import {createEntityAdapter, createSlice, SerializedError} from "@reduxjs/toolkit";
import {SuggestedAvailability} from "./types";
import {RootState} from "../../redux/store";
import {
    bookSuggestedAvailabilityThunk,
    confirmOrderThunk,
    getSuggestedAvailabilitiesThunk
} from "./suggestedAvailabilities.thunk";

type EnhancedState = {
    loading: boolean;
    error?: SerializedError;
}

const suggestedAvailabilitiesAdapter = createEntityAdapter<SuggestedAvailability>({
    selectId: (sA) => sA.workerId + "-" + sA.from,
    sortComparer: (a ,b) => a.to - b.from
})

const suggestedAvailabilitiesSlice = createSlice({
    name: "suggestedAvailabilities",
    initialState: suggestedAvailabilitiesAdapter.getInitialState({loading: false} as EnhancedState),
    reducers: {},
    extraReducers: (builder) =>
        builder
            .addCase(getSuggestedAvailabilitiesThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(getSuggestedAvailabilitiesThunk.fulfilled, (state, {payload}) => {
                state.loading = false;
                suggestedAvailabilitiesAdapter.setAll(state, payload);
            })
            .addCase(getSuggestedAvailabilitiesThunk.rejected, (state) => {
                state.loading = false;
            })
            .addCase(bookSuggestedAvailabilityThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(bookSuggestedAvailabilityThunk.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(bookSuggestedAvailabilityThunk.rejected, (state, action) => {
                state.loading = true;
                state.error = action.error;
            })
            .addCase(confirmOrderThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(confirmOrderThunk.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(confirmOrderThunk.rejected, (state, action) => {
                state.loading = true;
                state.error = action.error;
            })
});

export const {
    selectById: selectSuggestedAvailabilityById,
    selectIds: selectSuggestedAvailabilityIds,
    selectEntities: selectSuggestedAvailabilityEntities,
    selectAll: selectAllSuggestedAvailabilities,
    selectTotal: selectTotalSuggestedAvailabilities,
} = suggestedAvailabilitiesAdapter.getSelectors((state: RootState) => state.suggestedAvailabilities);

/*export const selectSuggestedDays = createSelector(
    selectAllSuggestedAvailabilities,
    (_state: RootState, props: { daysInMonth: number }) => _.fill(Array(props.daysInMonth), {
        suggestedAvailability: null,
    } as { suggestedAvailability: null | SuggestedAvailability }),
    (allSuggestedAvailabilities, suggestedDays) => {

    }
)*/

export default suggestedAvailabilitiesSlice.reducer;
